import { Component } from 'react';

import styles from './ComplionToolbar.scss';

class ComplionToolbarButton extends Component {
    render() {
        const { children, onMouseDown, active, disabled } = this.props;
        const className = active
            ? styles.complionToolbarButtonActive
            : styles.complionToolbarButton;
        return (
            <button type="button"
                className={className}
                disabled={disabled}
                onMouseDown={onMouseDown}
                data-cy="ComplionToolbarButton">
                { children }
            </button>
        );
    }
}

export default ComplionToolbarButton;